/*
 * @Author: your name
 * @Date: 2021-11-26 16:18:01
 * @LastEditTime: 2025-10-14 10:11:24
 * @LastEditors: yangguodong yanggd@geovis.com.cn
//  * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ngtc-traceability-admin\src\environments\environment.dev.ts
 */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'dev',
  production: false,
  apiServer: {
   earth: 'https://ngtc.asstar.com/service/',
  //  earth: 'http://localhost:8018/',
  },
};
